export const useCurrencyFormat = (
	amount: number | string,
	currency?: string
) => {
	currency = currency || 'USD'

	if (typeof amount !== 'number' && typeof amount !== 'string') {
		throw new TypeError('Amount must be a number or a string')
	}

	const formattedAmount = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency,
	}).format(Number(String(amount).replace(/,/g, '')))

	return formattedAmount
}
